import React from 'react';
import { Card, Row, Col, Button, Typography, Space } from 'antd';
import { RocketOutlined, TeamOutlined, TrophyOutlined, GlobalOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const Home: React.FC = () => {
  return (
    <div>
      <h1>Home</h1>
    </div>
  )
};

export default Home;